export default "__VITE_ASSET__BxwmIWP$__"